module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "icon_standings_list.e1bf96b9.svg";